import Button from '@atlaskit/button/standard-button';
import { PARTNER_FORM_STATUS_TYPES } from '@atlassian/mpac-api-client';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { Certification } from '@atlassian/mpac-ui';
import React from 'react';
import { ANALYTICS_EDIT_RESPONSES } from '../../analytics';
import { appTrustDataAdapter } from '../../AppTrustDataAdapter';
import { QuestionAnswerSection } from '../../CustomerComponents';
import { usePrivacySecurityAnalytics } from '../../hooks/usePrivacySecurityAnalytics';
import { privacySecurityConfig } from '../../privacySecurityConfig';
import { getQnA, updatePrivacySecurityConfig } from '../../utils';
import DraftStatus from '../DraftStatus/DraftStatus';
import PrivacyAndSecurityPreviewSectionMessages from '../PrivacyAndSecurityPreviewSectionMessages';
import { H2, Header, SectionHeading } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PrivacyAndSecurityPreview = _ref => {
  let {
    appListingData,
    liveAppTrustData,
    draftAppTrustData,
    appName,
    onEdit
  } = _ref;
  const {
    enableForgeRemoteDataResidencyChanges
  } = useStatsig();
  const transformedAppTrustData = appTrustDataAdapter(appListingData, liveAppTrustData);
  const {
    partner,
    cloudFortified
  } = transformedAppTrustData;
  const showDraftLabel = (draftAppTrustData === null || draftAppTrustData === void 0 ? void 0 : draftAppTrustData.properties.formStatus) === PARTNER_FORM_STATUS_TYPES.SAVED;
  const {
    fireButtonEvent,
    addScreenAttributes
  } = usePrivacySecurityAnalytics();
  const updatedprivacySecurityConfig = enableForgeRemoteDataResidencyChanges() ? updatePrivacySecurityConfig(privacySecurityConfig) : privacySecurityConfig;
  const handleEditResponses = () => {
    fireButtonEvent(ANALYTICS_EDIT_RESPONSES);
    onEdit();
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionHeading, {
      children: [/*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: "Privacy & Security Details"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleEditResponses,
          children: "Edit responses"
        })]
      }), /*#__PURE__*/_jsx(PrivacyAndSecurityPreviewSectionMessages, {
        liveAppTrustData: liveAppTrustData,
        addScreenAttributes: addScreenAttributes
      }), showDraftLabel && /*#__PURE__*/_jsx(DraftStatus, {
        timestamp: draftAppTrustData.properties.updatedAt,
        name: draftAppTrustData.properties.updatedBy
      })]
    }), updatedprivacySecurityConfig.map(_ref2 => {
      let {
        heading,
        expandText,
        qna
      } = _ref2;
      return /*#__PURE__*/_jsx(QuestionAnswerSection, {
        questionAndAnswers: getQnA(qna, transformedAppTrustData),
        heading: heading,
        expandButton: {
          text: expandText,
          maxCount: 3
        }
      }, heading);
    }), (cloudFortified === null || cloudFortified === void 0 ? void 0 : cloudFortified.isStatusApproved) && partner.name && partner.url && /*#__PURE__*/_jsx(Certification, {
      appName: appName,
      partnerName: partner.name,
      partnerUrl: partner.url
    })]
  });
};
export default PrivacyAndSecurityPreview;